/* eslint-disable no-unused-vars */
import '~/sass/pages/test-drive.scss';
import moment from 'moment';
import { getUserGeo } from '@/utils/geo-info';
import TestDriveCore from '@/components/module/TestDriveCore';

const { $, google } = window;

$(document).ready(() => {
  const driveCore = new TestDriveCore();
  // $('#btnAddTestDriveDateTime').on('click', (event) => {
  //   event.preventDefault();
  // });
});
